/**
 * Brand logo components using official Channelscaler SVG assets.
 *
 * Assets in /public:
 *   logo-icon.svg             — Gradient CS icon (favicon, small marks)
 *   logo-horizontal.svg       — Midnight wordmark (header on light bg)
 *   logo-tagline.svg          — Midnight wordmark + "Powering Partnerships" tagline
 *   logo-negative-tagline.svg — White wordmark + seafoam tagline (on dark/gradient bg)
 */

/** Header logo — icon + horizontal wordmark, midnight on light backgrounds */
export function Logo({ height = 32 }: { height?: number }) {
  return (
    <a href="/" className="flex items-center gap-2.5 shrink-0">
      <img src="/logo-icon.svg" alt="" height={height} width={height} style={{ height, width: height }} />
      <img
        src="/logo-horizontal.svg"
        alt="Channelscaler"
        className="hidden sm:block"
        style={{ height: height * 0.55 }}
      />
    </a>
  );
}

/** Full logo with tagline — used in larger hero contexts on light backgrounds */
export function LogoTagline({ height = 48 }: { height?: number }) {
  return (
    <img src="/logo-tagline.svg" alt="Channelscaler — Powering Partnerships" style={{ height }} />
  );
}

/** White/negative logo with tagline — for use on gradient or dark backgrounds */
export function LogoNegative({ height = 40 }: { height?: number }) {
  return (
    <img src="/logo-negative-tagline.svg" alt="Channelscaler — Powering Partnerships" style={{ height }} />
  );
}

/** Icon-only — for footers, small spaces */
export function LogoIcon({ size = 20, className = "" }: { size?: number; className?: string }) {
  return (
    <img src="/logo-icon.svg" alt="CS" width={size} height={size} className={className} style={{ width: size, height: size }} />
  );
}
